/**
 * Component for Exchange-Orders settings page in the Dashboard.
 *
 * @component
 */

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  message,
  Row,
  Select,
} from 'antd';
import axios from 'axios';
import React from 'react';
import Upgrade from '../../../../components/Upgrade';
import { SubscriptionContext } from '../../../../contexts/SubscriptionContext';
import { trackingVitally } from '../../../../helpers/vitally';

const { Option } = Select;

const FormItem = Form.Item;
class SettingsExchanges extends React.Component {
  static contextType = SubscriptionContext;

  constructor(props) {
    super(props);
    this.state = {
      exchangesEnableVariants: undefined,
      exchangesEnableSamePrice: undefined,
      exchangesEnableOverselling: undefined,
      autoExchange: false,
      exchangeType: 'draftOrder',
      autoExchangeStatus: 'Pending',
      inventoryStock: false,
      inventoryStockModal: false,
      productTagNames: [],
      productTagList: [],
      reserveStockFields: [],
      indexOfField: undefined,
      loading: true,
      oldReturnSettings: {},
      allowCustomerEditShippingAddress: true,
    };
  }
  formRef = React.createRef();

  async componentDidMount() {
    try {
      const response = await axios.get('/api/returnSettings');
      if (response.data == null) {
        this.setState({ loading: false });
        return;
      }
      this.setState({
        ...response.data,
        loading: false,
      });
    } catch (err) {
      this.setState({ loading: false });
      message.error('Error retrieving your return settings. Try again.', 5);
    }

    if (this.props.setSaveHandler) {
      this.props.setSaveHandler(this.handleSubmit);
    }
  }

  handleSubmit = async () => {
    try {
      const values = await this.formRef.current.validateFields();

      const response = await axios.post('/api/returnSettings/update', values);

      if (response.data.status === 'error') {
        return message.error(
          'Error updating your exchange settings. Please try again.',
          5
        );
      }trackingVitally('rr_exchangeorders_edited');

      this.setState({
        ...response.data,
      });

      return message.success('Return settings successfully updated.', 5);
    } catch (err) {
      if (err.errorFields) {
        return message.error(
          'There is something wrong with the data you entered. Please check again.',
          5
        );
      }

      return message.error(
        'Error updating your exchange settings. Please try again.',
        5
      );
    }
  };

  handleChange = (e) => {
    const target = e.target.id;
    this.setState({
      [target]: e.target.checked,
    });
  };

  handleExchangeOrderType = (value) => {
    this.setState({
      exchangeType: value,
    });
  };

  handleAutoExchangeStatus = (value) => {
    this.setState({
      autoExchangeStatus: value,
    });
  };

  deleteReserverField = async (field) => {
    let fields = this.state.reserveStockFields;
    let productList = this.state.productTagList;
    if (field?.variantId) {
      fields = fields.filter((value) => value.variantId !== field.variantId);
    } else {
      fields = fields.filter(
        (value) =>
          value.type !== 'Tag' ||
          !value.title.every((tag) => field.title.includes(tag))
      );
      productList = productList.filter((tag) => !field.title.includes(tag));
    }
    const payload = {
      reserveStockFields: fields,
      productTagList: productList,
    };
    try {
      const response = await axios.post('/api/returnSettings/update', payload);
      if (response.data.status === 'error') {
        return message.error(
          'Error updating your exchange settings. Please try again.',
          5
        );
      }
      this.setState({
        reserveStockFields: fields,
        productTagList: productList,
      });
      return message.success('Successfully deleted.', 5);
    } catch (err) {
      return message.error(
        `Error deleting the ${
          field.type === 'tag' ? 'tag' : 'product'
        }. Please try again.`,
        5
      );
    }
  };

  handleReserveEdit = (index) => {
    this.setState({
      indexOfField: index,
      inventoryStockModal: true,
    });
  };

  render() {
    if (this.state.loading) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <div className="GlobalLoader GlobalLoader--md"></div>
        </div>
      );
    }

    if (this.context.featureExchangeOrders === undefined) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <div className="GlobalLoader GlobalLoader--md"></div>
        </div>
      );
    }

    return (
      <React.Fragment>
        {this.context.featureExchangeOrders ? (
          <React.Fragment>
            <Row
              type="flex"
              justify="space-around"
              align="top"
              className="u-marginBottom--lg u-marginTop--md"
            >
              <Col span={22}>
                <p>
                  Create Orders and Draft-Orders for Exchanges directly from Rich
                  Returns.
                </p>
              </Col>
            </Row>
            <Form onFinish={this.handleSubmit} ref={this.formRef}>
              <Row
                type="flex"
                justify="space-around"
                align="middle"
                className="u-rowGap--sm"
              >
                <Col xs={22} sm={22} md={22} lg={22}>
                  <h4 data-intercom-target="attach-note-title-exchangeOrders-configuration-exchanges">Attach a note to the Exchange Order</h4>
                  <span>
                    Adds or appends a note to the order. You can use ORDER_NAME,
                    RMA_NUMBER and RETURN_METHOD as placeholders to insert
                    dynamic values.
                  </span>
                </Col>
                <Col xs={22} sm={22} md={22} lg={22}>
                  <FormItem
                    name="exchangeOrderNote"
                    valuePropName="checked"
                    initialValue={this.state.exchangeOrderNote}
                  >
                    <Checkbox
                      onChange={(e) => this.handleChange(e)}
                      data-intercom-target="attach-note-checkbox-exchangeOrders-configuration-exchanges"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </Col>
                {this.state.exchangeOrderNote && (
                  <React.Fragment>
                    <Col xs={22} sm={22} md={22} lg={22}>
                      <span>
                        This will attach a note to all exchange-orders.
                      </span>
                    </Col>
                    <Col xs={22} sm={22} md={22} lg={22} style={{display:'flex', justifyContent:'flex-start'}}>
                      
                      <FormItem 
                        name="exchangeOrderNoteValue" 
                        initialValue={this.state.exchangeOrderNoteValue}
                      >
                        <Input
                          placeholder="Exchange for order ORDER_NAME / Return RMA_NUMBER."
                          disabled={!this.state.exchangeOrderNote}
                          style={{ maxWidth: '440px' }}
                          data-intercom-target="attach-note-input-exchangeOrders-configuration-exchanges"
                        />
                      </FormItem>
                    </Col>
                  </React.Fragment>
                )}
              </Row>

              <Row type="flex" justify="space-around" align="top">
                <Col span={22}>
                  <Divider />
                </Col>
              </Row>

              <Row
                type="flex"
                justify="space-around"
                align="middle"
                className="u-rowGap--sm"
              >
                <Col xs={22} sm={22} md={22} lg={22}>
                  <h4 data-intercom-target="free-exchange-title-exchangeOrders-configuration-exchanges">Create a Free Exchange Order</h4>
                  <span>
                    This will create an exchange-order with prices of line-items
                    set to '0.00'. For Draft-Orders we apply a 100% discount to
                    all line-items due to a limitation by Shopify. If you
                    disable this setting we will create exchange orders &
                    draft-orders with full price line-items, note that in this
                    case you will have to collect any outstanding balance
                    manually e.g. through an invoice of a draft-order.
                  </span>
                </Col>
                <Col xs={22} sm={22} md={22} lg={22}>
                  <FormItem
                    name="exchangeOrderFreeExchange"
                    valuePropName="checked"
                    initialValue={this.state.exchangeOrderFreeExchange}
                  >
                    <Checkbox
                      onChange={(e) => this.handleChange(e)}
                      data-intercom-target="free-exchange-checkbox-exchangeOrders-configuration-exchanges"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </Col>
              </Row>
              <Row type="flex" justify="space-around" align="top">
                <Col span={22}>
                  <Divider />
                </Col>
              </Row>

              <Row
                type="flex"
                justify="space-around"
                align="middle"
                className="u-rowGap--sm"
              >
                <Col xs={22} sm={22} md={22} lg={22}>
                  <h4 data-intercom-target="restock-original-title-exchangeOrders-configuration-exchanges">Restock original items</h4>
                  <span>
                    This will enable the checkbox in the dialog where the
                    exchange-order is created. Can be changed manually for each
                    exchange-order later.
                  </span>
                </Col>
                <Col xs={22} sm={22} md={22} lg={22}>
                  <FormItem
                    name="exchangeOrderRestock"
                    valuePropName="checked"
                    initialValue={this.state.exchangeOrderRestock}
                  >
                    <Checkbox
                      onChange={(e) => this.handleChange(e)}
                      data-intercom-target="restock-original-checkbox-exchangeOrders-configuration-exchanges"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </Col>
              </Row>
              <Row type="flex" justify="space-around" align="top">
                <Col span={22}>
                  <Divider />
                </Col>
              </Row>

              <Row
                type="flex"
                justify="space-around"
                align="middle"
                className="u-rowGap--sm"
              >
                <Col xs={22} sm={22} md={22} lg={22}>
                  <h4 data-intercom-target="order-confirmation-title-exchangeOrders-configuration-exchanges">Order Confirmation</h4>
                  <span>
                    This will send your Shopify store's default order
                    confirmation email to the customer for the exchange order.
                    Note: this does not apply to draft-orders as
                    order-confirmations for draft-orders are sent out
                    automatically from Shopify when the actual order is created
                    later.
                  </span>
                </Col>
                <Col xs={22} sm={22} md={22} lg={22}>
                  <FormItem
                    name="exchangeOrderSendConfirmationReceipt"
                    valuePropName="checked"
                    initialValue={this.state.exchangeOrderSendConfirmationReceipt}
                  >
                    <Checkbox
                      onChange={(e) => this.handleChange(e)}
                      data-intercom-target="order-confirmation-checkbox-exchangeOrders-configuration-exchanges"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </Col>
              </Row>

              <Row type="flex" justify="space-around" align="top">
                <Col span={22}>
                  <Divider />
                </Col>
              </Row>

              {/* <Row type="flex" justify="space-around" align="top">
                  <Col span={22}>
                    <Divider />
                  </Col>
                </Row>

                <Row type="flex" justify="space-around" align="middle" className="u-rowGap--sm">
                  <Col xs={22} sm={22} md={22} lg={22}>
                    <h4>Use Shopify's native restocking functionality</h4>
                    <p>Any items selected to be restocked will be restocked in the original order just like you would restock them through your Shopify admin dashboard. Restocked items are visible in the timeline of the order and also marked as restocked in any Shopify reports.</p>
                    <p>If this option is disabled we'll restock items by increasing your inventory directly and leave the original order untouched.</p>
                  </Col>
                  <Col xs={22} sm={22} md={22} lg={22}>
                  </Col>
                </Row> */}

              <Row
                type="flex"
                justify="space-around"
                align="middle"
                className="u-rowGap--sm"
              >
                <Col xs={22} sm={22} md={22} lg={22}>
                  <h4 data-intercom-target="shipping-original-title-exchangeOrders-configuration-exchanges">Use Title of Original Shipping Method</h4>
                  <span>
                    This will use the title of the shipping method from the
                    original order for the exchange order. If disabled the
                    default shipping title "Free Shipping" is applied.
                  </span>
                </Col>
                <Col xs={22} sm={22} md={22} lg={22}>
                  <FormItem
                    name="exchangeOrderUseOriginalShippingTitle"
                    valuePropName="checked"
                    initialValue={this.state.exchangeOrderUseOriginalShippingTitle}
                  >
                    <Checkbox
                      onChange={(e) => this.handleChange(e)}
                      data-intercom-target="shipping-title-checkbox-exchangeOrders-configuration-exchanges"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </Col>
              </Row>

              <Row type="flex" justify="space-around" align="top">
                <Col span={22}>
                  <Divider />
                </Col>
              </Row>

              <Row
                type="flex"
                justify="space-around"
                align="middle"
                className="u-rowGap--sm"
              >
                <Col xs={22} sm={22} md={22} lg={22}>
                  <h4 data-intercom-target="customer-shipping-address-title-exchangeOrders-configuration-exchanges">Enable customer address update</h4>
                  <span>
                    If you want to allow your customer to change or update the delivery address, this option displays a screen in the exchange process for this purpose.
                  </span>
                </Col>
                <Col xs={22} sm={22} md={22} lg={22}>
                  <FormItem
                    name="allowCustomerEditShippingAddress"
                    valuePropName="checked"
                    initialValue={this.state.allowCustomerEditShippingAddress}
                  >
                    <Checkbox
                      onChange={(e) => this.handleChange(e)}
                      data-intercom-target="allow-customer-edit-shipping-address-checkbox-exchangeOrders-configuration-exchanges"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </Col>
              </Row>

              <React.Fragment>
                <Row type="flex" justify="space-around" align="top">
                  <Col span={22}>
                    <Divider />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  className="u-rowGap--sm"
                >
                  <Col xs={22} sm={22} md={22} lg={22}>
                    <h4 data-intercom-target="autoexchange-title-exchangeOrders-configuration-exchanges">Enable AutoExchange</h4>
                    <span>
                      Check this box if you want to automatically create an
                      exchange order for the return initiated by a customer.
                    </span>
                  </Col>
                  <Col xs={22} sm={22} md={22} lg={22}>
                    <FormItem
                      name="autoExchange"
                      valuePropName="checked"
                      initialValue={this.state.autoExchange}
                    >
                      <Checkbox
                        onChange={(e) => this.handleChange(e)}
                        data-intercom-target="autoexchange-checkbox-exchangeOrders-configuration-exchanges"
                      >
                        Enable
                      </Checkbox>
                    </FormItem>
                  </Col>
                </Row>
              </React.Fragment>

              <React.Fragment>
                <Row type="flex" justify="space-around" align="top">
                  <Col span={22}>
                    <Divider />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  className="u-rowGap--sm"
                >
                  <Col xs={22} sm={22} md={22} lg={22}>
                    <h4 data-intercom-target="select-order-type-title-exchangeOrders-configuration-exchanges">Select order type</h4>
                    <span>
                      Select the order type while creating auto exchange for the
                      return initiated by a customer. i.e, Exchange Order, Draft
                      Order.
                    </span>
                  </Col>
                  <Col xs={22} sm={22} md={22} lg={22}>
                    <FormItem style={{ maxWidth: '440px' }} label="Exchange type" name="exchangeType" initialValue={this.state.exchangeType}>
                      <Select
                        onChange={this.handleExchangeOrderType.bind(this)}
                        disabled={!this.state.autoExchange}
                        data-intercom-target="order-type-select-exchangeOrders-configuration-exchanges"
                      >
                        <Option value="exchangeOrder" key="exchangeOrder">Exchange Order</Option>
                        <Option value="draftOrder" key="draftOrder">Draft Order</Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
              </React.Fragment>

              <Row
                type="flex"
                justify="space-around"
                align="middle"
                className="u-rowGap--sm u-marginTop--md"
              >
                <Col xs={22} sm={22} md={22} lg={22}>
                  <span>
                    Choose a return status for which the exchange order should
                    be created automatically.
                  </span>
                </Col>
                <Col xs={22} sm={22} md={22} lg={22}>
                  <FormItem
                    name="autoExchangeStatus"
                    label="Select Status"
                    initialValue={this.state.autoExchangeStatus}
                    style={{ maxWidth: '440px' }}
                  >
                    <Select
                      disabled={!this.state.autoExchange}
                      onChange={this.handleAutoExchangeStatus.bind(this)}
                      data-intercom-target="autoexchange-status-select-exchangeOrders-configuration-exchanges"
                    >
                      <Option value="Pending" key="Pending">Pending</Option>
                      <Option value="Approved" key="Approved">Approved</Option>
                        <Option value="In Transit">In Transit</Option>
                      <Option value="Shipped" key="Shipped">Shipped</Option>
                      <Option value="Received" key="Received">Received</Option>
                      <Option value="Resolved" key="Resolved">Resolved</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>

              <Row
                type="flex"
                justify="space-around"
                align="top"
                className="u-marginTop--xlg"
              >
                <Col span={22}>
                  <FormItem>
                    <Row type="flex" justify="end" align="top">
                      <Button type="primary" htmlType="submit" data-intercom-target="save-button-exchangeOrders-configuration-exchanges">
                        Save changes
                      </Button>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </React.Fragment>
        ) : (
          <Upgrade
            title="A faster way to process Exchanges."
            description="Upgrade to the Premium Plan to create Exchange-Orders directly from your Rich Returns dashboard."
          />
        )}
      </React.Fragment>
    );
  }
}

export default SettingsExchanges;
